export enum ArtworkReaction {
  Like = 'like',
  Heart = 'heart',
  Surprise = 'surprise',
}
